import { Component, input, Injectable } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NativeDateAdapter, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';

import { MaterialModule } from '@app/material.module';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override parse(value: any): Date | null {
    if (typeof value === 'string' && value.indexOf('/') > -1) {
      const parts = value.split('/');
      if (parts.length === 3) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; 
        let year = parseInt(parts[2], 10);

        if (year < 100) {
          year += year < 50 ? 2000 : 1900;
        }
        return new Date(year, month, day);
      }
    }
    return super.parse(value);
  }
}

@Component({
  selector: 'datepicker-field',
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_LOCALE, useValue: 'es-PE' } 
  ],
  imports: [ReactiveFormsModule, CommonModule, MaterialModule],
  templateUrl: './datepicker-field.component.html',
})
export class DatepickerFieldComponent {
  control = input.required<FormControl>();
  label = input.required<string>();
  appendTo = input<string | HTMLElement | undefined>(undefined);
  panelStyleClass = input<string | undefined>(undefined);
  inputStyleClass = input<string | undefined>(undefined);
  minDate = input<Date | null>(null);
  maxDate = input<Date | null>(null);
}